<template>
  <info-container title="Installer">
    <div class="tw-mt-3 tw-w-60 tw-h-35">
      <form-field
        label="Installer"
        :options="partners"
        null-option="Select installer"
        type="select"
        :value="value"
        @input="onInstallerChange"
      />
    </div>
  </info-container>
</template>

<script setup>
import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import FormField from '@/components/shared/FormField.vue'
import InfoContainer from '@/components/shared/InfoContainer.vue'
import fetchData from '@/util/fetch'

const props = defineProps({
  value: String,
})

const emit = defineEmits(['input', 'saveLayout'])

const onInstallerChange = (value) => {
  emit('input', value)
  emit('saveLayout')
}

const getPartners = () => fetchData('/tickets/api/v1/partners')
const partnersQuery = useQuery({
  queryKey: ['partners'],
  queryFn: getPartners,
})

const partners = computed(() => partnersQuery.data?.value?.data?.map((p) => p.legacy_name) || [])
</script>
